import { useContext } from 'react';
import { useMatch } from 'react-router-dom';
import { AppConfigContext } from '../../utilities/appConfig';
import { APP_ROLES } from '../constants';
import languageTranslation from '../common/languageTranslation';

export default function useMenu() {
	const config = useContext(AppConfigContext);
	// Connectors nav is gated until connectors are published
	const showConnectors = config?.['connectorsfeatureflag']?.enabled;
	// Call all useMatch hooks at the top level
	const clientOrgsMatch = useMatch('/client-orgs');
	const clientProjectsMatch = useMatch('/client-projects/*');
	const siPartnerProjectsMatch = useMatch('/si-partner-projects/*');
	const templateManagerMatch = useMatch('/template-manager');
	const siPartnersMatch = useMatch('/si-partners');
	const rolesMatch = useMatch('/roles');
	const projectsMatch = useMatch('/projects/*');
	const siProjectsMatch = useMatch('/si-projects/*');
	const certificateMatch = useMatch('/certificate');
	const membersMatch = useMatch('/members');
	const connectorsMatch = useMatch('/connectors');
	const partnersMatch = useMatch('/partners');
	const discoveryManagerMatch = useMatch('/discovery-manager');

	const appRoutes = [
		{
			id: 'client-orgs-nav',
			title: 'Client orgs',
			icon: 'home',
			pathname: '/client-orgs',
			active: clientOrgsMatch,
			roles: [APP_ROLES.CLIENT_ADMIN, APP_ROLES.ESI_CLIENT_ADMIN]
		},
		{
			id: 'client-projects-nav',
			title: 'Client projects',
			icon: 'work',
			pathname: '/client-projects',
			active: clientProjectsMatch || siPartnerProjectsMatch,
			roles: [APP_ROLES.CLIENT_ADMIN, APP_ROLES.ESI_CLIENT_ADMIN]
		},
		{
			id: 'template-manager-nav',
			title: 'Template manager',
			icon: 'media-file',
			pathname: '/template-manager',
			active: templateManagerMatch,
			roles: [APP_ROLES.TEMPLATE_ADMIN, APP_ROLES.ESI_TEMPLATE_ADMIN]
		},
		{
			id: 'discovery-manager-nav',
			title: 'Discovery manager',
			icon: 'action-hide',
			pathname: '/discovery-manager',
			active: discoveryManagerMatch,
			roles: [APP_ROLES.TEMPLATE_ADMIN]
		},
		{
			id: 'si-partners-nav',
			title: 'SI Partners',
			icon: 'user-group',
			pathname: '/si-partners',
			active: siPartnersMatch,
			roles: [APP_ROLES.CLIENT_ADMIN, APP_ROLES.ESI_CLIENT_ADMIN]
		},
		{
			id: 'roles-nav',
			title: 'Roles',
			icon: 'user-avatar',
			pathname: '/roles',
			active: rolesMatch,
			roles: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ESI_SUPER_ADMIN]
		},
		{
			id: 'projects-nav',
			title: languageTranslation('projects.title'),
			icon: 'home',
			pathname: '/projects',
			active: projectsMatch || siProjectsMatch,
			roles: [APP_ROLES.PROJECT_USER, APP_ROLES.ESI_PROJECT_USER]
		},
		{
			id: 'certificate',
			title: languageTranslation('certificate.title'),
			icon: 'action-view-bookmarks',
			pathname: '/certificate',
			active: certificateMatch,
			roles: [APP_ROLES.CERTIFICATE_USER, APP_ROLES.ESI_CERTIFICATE_USER]
		},
		{
			id: 'members-nav',
			title: languageTranslation('members.heading'),
			icon: 'user-avatar',
			pathname: '/members',
			active: membersMatch,
			roles: [APP_ROLES.MEMBER_USER, APP_ROLES.ESI_MEMBER_USER]
		},
		{
			id: 'connectors-nav',
			title: 'Connectors',
			icon: 'action-link',
			pathname: '/connectors',
			active: connectorsMatch,
			roles: [APP_ROLES.PROJECT_USER, APP_ROLES.ESI_PROJECT_USER]
		},
		{
			id: 'partners-nav',
			title: 'Integration Services',
			icon: 'toolbox',
			pathname: '/partners',
			active: partnersMatch,
			roles: [APP_ROLES.PROJECT_USER, APP_ROLES.ESI_PROJECT_USER]
		}
	];

	const visibleRoutes = appRoutes.filter((r) => r.id !== 'connectors-nav' || showConnectors);
	return [{ appRoutes: visibleRoutes }];
}
